import FJTextToImageDataConfig from '../../config/dataConfig/FJTextToImageDataConfig';
import FJConfig from '../../config/FJConfig';
import FJConstant from '../../constants/FJConstant';
import FJTextToImageConstant from '../../constants/FJTextToImageConstant';
import FJCompressedImageStore from '../../store/FJCompressedImageStore';
import FJImageStore from '../../store/FJImageStore';
import FJLocalStore from '../../store/FJLocalStore';
import FJMessageStore from '../../store/FJMessageStore';
import FJNetworkStore from '../../store/FJNetworkStore';
import FJUtil from '../../util/FJUtil';
import { setSliceCreationListAction, setSliceTaskStatusAction } from '../slices/FJSliceCommon';
import {
    setSliceCurGeneratingPromptImageUrl,
    setSliceGenerateNumber,
    setSliceInspireList,
    setSliceIsShowPresetImageBox,
    setSliceModel,
    setSlicePresetImageList,
    setSlicePrompt,
    setSlicePromptStatus,
    setSliceStyle,
    setSliceStyleList,
} from '../slices/FJSliceTextToImage';
import FJActionCommon from './FJActionCommon';
import FJActionModal from './FJActionModal';
import FJActionGuide from './FJActionGuide.js';

let _text2imgEventIdList = [];
let _imageRecognitionStatus = false; // 图片识别状态  false 表示未识别  true 表示正在识别
let _aiOptimizingStatus = false; // AI优化状态  false 表示未优化  true 表示正在优化

const FJActionTextToImage = {
    resetAction: function () {
        return dispatch => {
            dispatch(setSliceIsShowPresetImageBox(true));
            // dispatch(setSliceGenerateNumber(2));
            dispatch(setSlicePrompt(''));
            // dispatch(setSliceStyle({ value: '', name: 'none', previewImg: 'none.jpg' }));
            // dispatch(setSliceModel('schnell'));
            // dispatch(setSliceRatio('1:1'));
        };
    },
    changePromptAction: function (newPrompt) {
        return (dispatch, getState) => {
            const { prompt } = getState().textToImage;

            if (prompt === newPrompt) return;

            dispatch(setSlicePrompt(newPrompt));
        };
    },

    generateAction: function () {
        return async (dispatch, getState) => {
            const promptStatus = getState().textToImage.promptStatus;

            if (promptStatus !== FJTextToImageConstant.NORMAL) {
                return;
            }

            const { prompt, curModel, curRatio, generateNumber, curStyle } = getState().textToImage;
            const { creditNumber, freeNumCreation } = getState().common;
            const hasFreeCreation = freeNumCreation > 0;
            const curModelData = FJTextToImageDataConfig.MODELS.find(item => item.value === curModel);
            const curModelUseCredit = curModelData?.useCredit;
            const curRatioData = FJTextToImageDataConfig.RATIO_LIST.find(item => item.name === curRatio);
            const curRatioValue = curRatioData?.value;

            let isFree = false;
            const size = {
                width: 512,
                height: 512 / curRatioValue,
            };

            FJUtil.eaLog('ai tools text to image generate click', {
                prompt,
                'prompt language': FJUtil.getStringLanguage(prompt),
                style: curStyle.name === 'none' ? '' : curStyle.name,
                mode: curModelData.name,
                ratio: curRatioValue,
                number: generateNumber,
            });

            if (!FJUtil.isLogin() || FJUtil.isFreePayment()) {
                FJUtil.eaLog('AI Tools guide AB generate click 2025.4.14', {
                    tool: 'text to image',
                    AB: FJUtil.getAB(),
                });
            }

            const __errorCallback = failTaskCount => {
                if (!failTaskCount) {
                    dispatch(setSliceCreationListAction([]));
                } else {
                    const creationList = [...getState().common.creationList];

                    const allTaskListLength = creationList.length;

                    for (let i = allTaskListLength - failTaskCount; i < allTaskListLength; i++) {
                        creationList[i].isLoading = false;
                        creationList[i].isReload = true;
                    }
                    dispatch(setSliceCreationListAction(creationList));
                }

                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
            };

            const __judgeCanGenerate = async () => {
                const _prompt = prompt.replace(/\s/g, '');
                if (_prompt.length === 0 || prompt.length === 0) {
                    FJMessageStore.addMessage(FJLocalStore._('please-enter-the-prompt'), 'error');
                    return false;
                }

                const userSpaceType = await FJUtil.checkUserSpace({
                    errorCallback: () => {
                        FJMessageStore.addMessage(
                            FJLocalStore._('failed-to-generate-the-image-please-try-it-again'),
                            'error',
                        );
                    },
                });
                if (userSpaceType > 0) {
                    dispatch(FJActionCommon.userSpaceChangeAction(userSpaceType));
                    return false;
                }

                const useCredit = curModelUseCredit * generateNumber;

                //4.额度判断
                const canFreeCreate =
                    hasFreeCreation && generateNumber <= 2 && curModel === FJTextToImageDataConfig.MODELS[0].value;

                if (creditNumber < useCredit && !canFreeCreate) {
                    dispatch(FJActionModal.showUpgradeModalAction());
                    return false;
                }
                isFree = creditNumber < useCredit && canFreeCreate;
                return true;
            };

            // 修改状态生成占位符
            const placeHolderList = FJUtil.createPlaceHolderListNew({
                count: generateNumber,
                width: size.width,
                height: size.height,
                type: FJConstant.CREATIONS,
            });

            dispatch(FJActionCommon.setHeaderTabIndexAction(0));
            dispatch(setSliceTaskStatusAction(FJConstant.START));

            const isCanGenerate = await __judgeCanGenerate();

            if (!isCanGenerate) {
                __errorCallback();
                return;
            }

            dispatch(setSliceIsShowPresetImageBox(false));
            dispatch(setSliceCreationListAction(placeHolderList));

            try {
                //文字翻译
                const trimPrompt = prompt.replace(/\s+/g, ' ');
                const usePrompt = await this._translatePrompt(trimPrompt);

                _text2imgEventIdList = [];

                const request = async () => {
                    return await FJNetworkStore.textToImage({
                        prompt: usePrompt,
                        input_prompt: trimPrompt,
                        model_type: curModel,
                        ratio: curRatio,
                        style: curStyle.name === 'none' ? '' : curStyle.name,
                        prompt_val: curStyle.value,
                        generateNumber: curModel === 'pro' ? 1 : generateNumber,
                    });
                };

                if (curModel === 'pro') {
                    for (let i = 0; i < generateNumber; i++) {
                        const eventId = await FJActionCommon.createRequestTask(request, dispatch);
                        _text2imgEventIdList.push(eventId);
                    }
                } else {
                    const eventId = await FJActionCommon.createRequestTask(request, dispatch);
                    _text2imgEventIdList.push(eventId);
                }
                FJUtil.updateAllCreditInfo();
                //7.轮询任务状态
                const callback = data => {
                    const { type } = data;
                    if (type === FJConstant.ERROR) {
                        __errorCallback();
                    }

                    // 将失败的任务更改为失败状态
                    if (type === FJConstant.SUCCESS && data.failTaskCount > 0) {
                        __errorCallback(data.failTaskCount);
                    }

                    FJUtil.setLocalStorage();
                    if (type === FJConstant.SUCCESS) {
                        FJUtil.eaLog('ai tool generate success', {
                            tool: FJUtil.getToolName(),
                            'credit&free': isFree ? 'free' : 'credit',
                        });
                    }
                };
                const tool = FJUtil.getToolName();
                FJUtil.eaLog('ai tool start generating', { 'credit&free': isFree ? 'free' : 'credit', tool });
                dispatch(
                    FJActionCommon.pollingTaskAction(_text2imgEventIdList, {
                        callback,
                        progressNumber: generateNumber,
                        isUseFree: isFree,
                    }),
                );
            } catch (error) {
                __errorCallback();
            }
        };
    },

    onClickUsePromptAction: function (presetData) {
        return async (dispatch, getState) => {
            const promptStatus = getState().textToImage.promptStatus;

            if (promptStatus !== FJTextToImageConstant.NORMAL) {
                return;
            }

            const { prompt, model_type, style } = presetData;

            // 模型选择 规则不一致 不统一
            if (model_type) {
                const { creditNumber } = getState().common;
                if (creditNumber === 0) {
                    dispatch(setSliceModel(FJTextToImageDataConfig.MODELS[0].value));
                } else {
                    const modelValue = FJTextToImageDataConfig.MODELS.find(item => item.name === model_type)?.value;
                    modelValue && dispatch(setSliceModel(modelValue));
                }
            }

            if (style) {
                const styleList = getState().textToImage.styleList;
                let styleData = null;
                styleList.forEach(item => {
                    item.list.forEach(item => {
                        if (item.name === style) {
                            styleData = item;
                        }
                    });
                });

                styleData && dispatch(setSliceStyle(styleData));
            }

            dispatch(this.changePromptAction(prompt));
        };
    },

    /**
     * 修改生成数量
     * @param {number} newGenerateNumber
     * @returns
     */
    changeGenerateNumberAction: function (newGenerateNumber) {
        return (dispatch, getState) => {
            const { generateNumber } = getState().textToImage;

            if (generateNumber === newGenerateNumber) return;

            const isLogin = FJUtil.isLogin();

            if (isLogin) {
                const { creditNumber, freeNumCreation } = getState().common;
                const curModel = getState().textToImage.curModel;
                const modelUseCredit = FJTextToImageDataConfig.MODELS.find(item => item.value === curModel)?.useCredit;

                if (
                    creditNumber < modelUseCredit * newGenerateNumber &&
                    (freeNumCreation === 0 || newGenerateNumber > 2)
                ) {
                    dispatch(FJActionModal.showUpgradeModalAction());
                    return;
                }
            }

            // 存储在本地 下次用户进入时使用
            localStorage.setItem('generateNumber', newGenerateNumber);
            dispatch(setSliceGenerateNumber(newGenerateNumber));
        };
    },

    /**
     * @desc 获取灵感
     * @returns
     */
    getInspireAction: function () {
        return async (dispatch, getState) => {
            const promptStatus = getState().textToImage.promptStatus;
            if (promptStatus !== FJTextToImageConstant.NORMAL) {
                return;
            }

            const inspireList = getState().textToImage.inspireList;

            if (!inspireList) {
                return;
            }

            const curLang = FJLocalStore.currentTag();
            const inspireListByLang = inspireList[curLang] || inspireList['en'];
            const curPrompt = getState().textToImage.prompt;

            const __getRandomInspire = () => {
                const randomIndex = Math.floor(Math.random() * inspireListByLang.length);

                if (inspireListByLang[randomIndex] === curPrompt) {
                    return __getRandomInspire();
                }
                return inspireListByLang[randomIndex];
            };

            let prompt = __getRandomInspire();

            dispatch(this.changePromptAction(prompt));
        };
    },

    initTextToImageDataAction: function () {
        return async dispatch => {
            await dispatch(this.initTextToImageStaticDataAction());
            dispatch(this._loadTextToImageParamsAction());
        };
    },

    /**
     * @desc 文生图带参数访问加载
     * @returns
     */
    _loadTextToImageParamsAction: function () {
        return async (dispatch, getState) => {
            const recId = FJUtil.getQueryString(FJConstant.REC_ID);
            const recIdInfo = recId ? JSON.parse(window.localStorage.getItem(recId)) : null;
            if (recIdInfo) {
                window.localStorage.removeItem(recId);
                const { style, prompt } = recIdInfo;

                dispatch(this.changeModelAction(FJTextToImageDataConfig.MODELS[0].value, false));
                const styleList = getState().textToImage.styleList;

                let styleData = null;
                styleList.forEach(item => {
                    item.list.forEach(item => {
                        if (item.name === style) {
                            styleData = item;
                        }
                    });
                });

                styleData && dispatch(setSliceStyle(styleData));
                dispatch(this.changePromptAction(prompt));
            } else {
                dispatch(FJActionGuide.showTextToImageGuideModal());
            }
        };
    },

    /**
     * @desc 初始化文生图静态数据
     * @returns
     */
    initTextToImageStaticDataAction: function () {
        return async dispatch => {
            await dispatch(this._initStylesAction());
            await dispatch(this._initInspireListAction());
            await dispatch(this._initPresetImageListAction());
        };
    },

    _translatePrompt: async function (prompt) {
        const isEnglish = FJUtil.isEnglish(prompt);

        if (isEnglish) {
            return prompt;
        }
        const postData = [{ text: prompt }];
        const result = await FJNetworkStore.translateValueToLanguage(postData);
        const usePrompt = result[0].translations[0].text;

        return usePrompt;
    },

    /**
     * 初始化灵感列表
     * @returns
     */
    _initInspireListAction: function () {
        return async dispatch => {
            const response = await fetch(FJConfig.inspireListJsonPath);
            const inspireList = await response.json();
            dispatch(setSliceInspireList(inspireList));
        };
    },

    /**
     * 初始化文生图风格列表
     * @returns
     */
    _initStylesAction: function () {
        return async dispatch => {
            const response = await fetch(FJConfig.stylesJsonPath);
            const resultData = await response.json();

            const stylesData = resultData.map(item => {
                return {
                    categoryName: item.categoryName,
                    list: item.list.map(item => ({
                        value: item.value,
                        name: item.name,
                        previewImg: `${FJConfig.stylePreviewPath}${item.previewImg}`,
                    })),
                };
            });

            dispatch(setSliceStyle(stylesData[0].list[0]));
            dispatch(setSliceStyleList(stylesData));
        };
    },

    _initPresetImageListAction: function () {
        return async dispatch => {
            const response = await fetch(FJConfig.presetImageListJsonPath);
            const allPresetImageList = await response.json();

            const getRandomIndexes = (length, count) => {
                const indexes = [];
                while (indexes.length < count) {
                    const randomIndex = Math.floor(Math.random() * length);
                    if (!indexes.includes(randomIndex)) {
                        indexes.push(randomIndex);
                    }
                }
                return indexes;
            };

            const randomIndexes = getRandomIndexes(allPresetImageList.length, 3);

            const curPresetImageList = randomIndexes.map(index => {
                return {
                    imageUrl: `${FJConfig.presetImagePreviewPath}${allPresetImageList[index].imageUrl}`,
                    model_type: allPresetImageList[index].model_type,
                    style: allPresetImageList[index].style,
                    prompt: allPresetImageList[index].prompt,
                };
            });

            dispatch(setSlicePresetImageList(curPresetImageList));
        };
    },

    /**
     * 使用图片作为提示
     * @param {File | Blob} file
     * @returns
     */
    useImageAsPromptAction: function (file) {
        return async (dispatch, getState) => {
            const promptStatus = getState().textToImage.promptStatus;

            if (promptStatus !== FJTextToImageConstant.NORMAL) {
                return;
            }
            FJUtil.eaLog('ai tools text to image get prompts from image');

            _imageRecognitionStatus = true;
            dispatch(setSlicePromptStatus(FJTextToImageConstant.IMAGE_IMPORTING));
            dispatch(FJActionModal.hideUploadImageAsPromptModalAction());

            // 取消图片识别 | 中断生成 执行副作用
            const __cancelImageRecognitionCallback = () => {
                dispatch(setSlicePromptStatus(FJTextToImageConstant.NORMAL));
                dispatch(setSliceCurGeneratingPromptImageUrl(''));
            };

            const mimes = [
                'image/xbm',
                'image/tif',
                'image/apng',
                'image/jpg',
                'image/jpeg',
                'image/ico',
                'image/jfif',
                'image/webp',
                'image/png',
                'image/bmp',
                'application/octet-stream',
            ];
            const extensions = ['xbm', 'tif', 'apng', 'jpg', 'jpeg', 'ico', 'jfif', 'webp', 'png', 'bmp'];

            // 检查文件类型和后缀名
            const isValidType = file.type && mimes.includes(file.type);
            const extension = file.name ? file.name.split('.').pop().toLowerCase() : '';
            const isValidExtension = extension !== '' && extensions.includes(extension);

            if (!isValidType && !isValidExtension) {
                FJMessageStore.addMessage(FJLocalStore._('image-get-prompt-unsupported'), 'error');
                __cancelImageRecognitionCallback();
                return;
            }

            const imageData = await FJCompressedImageStore.compressImageByFile(file, { maxPixel: 400 });

            if (!_imageRecognitionStatus) {
                __cancelImageRecognitionCallback();
                return;
            }

            if (!imageData) {
                FJMessageStore.addMessage(FJLocalStore._('image-get-prompt-unsupported'), 'error');
                __cancelImageRecognitionCallback();
                return;
            }
            dispatch(setSliceCurGeneratingPromptImageUrl(imageData.src));

            const userSpaceType = await FJUtil.checkUserSpace({
                errorCallback: () => {
                    FJMessageStore.addMessage(FJLocalStore._('image-get-prompt-word-failed'), 'error');
                },
            });
            if (userSpaceType > 0) {
                dispatch(FJActionCommon.userSpaceChangeAction(userSpaceType));
                __cancelImageRecognitionCallback();
                return;
            }

            // 2. 上传图片
            const result = await FJImageStore.upLoadFileToS3ByUrl(imageData.src, { isCompress: false });

            if (!_imageRecognitionStatus || !result) {
                __cancelImageRecognitionCallback();
                return;
            }

            // 3. 生成图片描述
            const currentLang = FJLocalStore.currentTag();
            const { data, code } = await FJNetworkStore.generateImageByPrompt(result, currentLang);
            if (!_imageRecognitionStatus) {
                // 操作被用户取消
                return;
            }
            if (code === 200) {
                _imageRecognitionStatus = false;
                const prompt = data.prompt;
                dispatch(this.changePromptAction(prompt));
            } else {
                FJMessageStore.addMessage(FJLocalStore._('image-get-prompt-word-failed'), 'error');
            }
            dispatch(setSlicePromptStatus(FJTextToImageConstant.NORMAL));
        };
    },

    uploadImageUrlAction: function (url, options = {}) {
        return dispatch => {
            const __urlToBlob = async url => {
                try {
                    const response = await fetch(url);
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    const blob = await response.blob();
                    const { name } = options;
                    name && (blob.name = name);
                    return blob;
                } catch (error) {
                    console.error('Error fetching the URL:', error);
                }
            };
            __urlToBlob(url).then(blob => {
                dispatch(this.useImageAsPromptAction(blob));
            });
        };
    },

    /**
     * @desc AI提示词优化
     * @returns
     */
    aiOptimizingAction: function () {
        return async (dispatch, getState) => {
            const promptStatus = getState().textToImage.promptStatus;

            if (promptStatus !== FJTextToImageConstant.NORMAL) {
                return;
            }

            const prompt = getState().textToImage.prompt;
            FJUtil.eaLog('ai tools text to image ai prompts click', { prompt });

            const _prompt = prompt.replace(/\s/g, '');
            if (_prompt.length === 0 || prompt.length === 0) {
                FJMessageStore.addMessage(FJLocalStore._('please-enter-the-prompt'), 'error');
                return;
            }

            const userSpaceType = await FJUtil.checkUserSpace({
                errorCallback: () => {
                    FJMessageStore.addMessage(FJLocalStore._('ai-optimization-prompts-failed'), 'error');
                },
            });
            if (userSpaceType > 0) {
                dispatch(FJActionCommon.userSpaceChangeAction(userSpaceType));
                return false;
            }

            _aiOptimizingStatus = true;
            dispatch(setSlicePromptStatus(FJTextToImageConstant.AI_OPTIMIZING));

            const { data, code } = await FJNetworkStore.aiOptimizing(prompt);

            if (!_aiOptimizingStatus) {
                return;
            }

            if (code === 200) {
                const prompt = data.prompt;
                const cleanedPrompt = prompt.replace(/^“|”$/g, '');
                dispatch(this.changePromptAction(cleanedPrompt.replace(/^"|"$/g, '')));
            } else {
                FJMessageStore.addMessage(FJLocalStore._('ai-optimization-prompts-failed'), 'error');
            }

            dispatch(setSlicePromptStatus(FJTextToImageConstant.NORMAL));
        };
    },

    /**
     * 取消图片识别
     * @returns
     */
    cancelImageRecognitionAction: function () {
        return async dispatch => {
            _imageRecognitionStatus = false;
            dispatch(setSlicePromptStatus(FJTextToImageConstant.NORMAL));
            dispatch(setSliceCurGeneratingPromptImageUrl(''));
        };
    },

    /**
     * 取消AI优化
     * @returns
     */
    cancelAiOptimizingAction: function () {
        return async dispatch => {
            _aiOptimizingStatus = false;
            dispatch(setSlicePromptStatus(FJTextToImageConstant.NORMAL));
        };
    },

    /**
     * 修改模型
     * @param {string} model
     * @returns
     */
    changeModelAction: function (model, isOpenUpgradeModal = true) {
        return async (dispatch, getState) => {
            const isLogin = FJUtil.isLogin();

            if (isLogin) {
                const { creditNumber } = getState().common;
                const modelData = FJTextToImageDataConfig.MODELS.find(item => item.value === model);
                const generateNumber = getState().textToImage.generateNumber;

                if (
                    creditNumber < modelData.useCredit * generateNumber &&
                    modelData.name !== FJTextToImageDataConfig.MODELS[0].name
                ) {
                    if (isOpenUpgradeModal) {
                        dispatch(FJActionModal.showUpgradeModalAction());
                    } else {
                        // 不弹出弹窗 默认选中基础模型
                        dispatch(setSliceModel(FJTextToImageDataConfig.MODELS[0].value));
                    }
                    return;
                }
            }

            dispatch(setSliceModel(model));
        };
    },
};

export default FJActionTextToImage;
